import React from "react";
import logoletras from "../../asset/image/Logos/logoletras.png";
import felicidad from "../../asset/image/Logos/felicidad.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-custom-green-ccard-2 border-t-4 border-custom-green-ccard-1 mt-auto">
      <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <img
            src={logoletras}
            alt="CentroCard"
            className="h-6 object-contain"
            style={{ filter: "brightness(0) invert(1)" }}
          />
          <span className="text-green-200 text-xs hidden sm:inline">
            — Intranet Corporativa
          </span>
        </div>
        <p className="text-green-100 text-xs text-center">
          © {currentYear} CentroCard. Todos los derechos reservados.
        </p>
        <div className="items-center gap-2 hidden sm:flex">
          <span className="text-green-300 text-xs">
            Uso interno exclusivo
          </span>
          <img
            src={felicidad}
            alt="Felicidad"
            className="h-6 object-contain"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
